import { Button } from "@bcc/components/ui/button";
import type { DataTableRow } from "@client-shared";
import type { LabelPrintBatch } from "@shared/types";
import type { CellContext } from "@tanstack/react-table";
import { Eye } from "lucide-react";
import { useTranslation } from "react-i18next";
import { setBatchesTableActionTestId } from "../batches-table.utils";

interface BatchActionsCellOptions {
  onSelectBatch?: (batchId: string) => void;
}

export const createBatchActionsCellMarkup = ({ onSelectBatch }: BatchActionsCellOptions) => {
  const BatchActionsCellMarkup = (props: CellContext<DataTableRow<LabelPrintBatch>, unknown>) => {
    const { t } = useTranslation();
    const batchId = props.row.original.batchId;

    return (
      <div className="flex items-center justify-end gap-1">
        <Button
          type="button"
          size="icon-sm"
          variant="ghost"
          testId={setBatchesTableActionTestId(batchId, "view")}
          aria-label={t("views.batchesTable.tooltips.viewBatch")}
          onClick={(event) => {
            event.stopPropagation();
            onSelectBatch?.(batchId);
          }}
        >
          <Eye className="h-4 w-4" />
          <span className="sr-only">{t("views.batchesTable.tooltips.viewBatch")}</span>
        </Button>
      </div>
    );
  };

  BatchActionsCellMarkup.displayName = "BatchActionsCellMarkup";

  return BatchActionsCellMarkup;
};
